import loadedObservableEvent from "@newswebsiteapp/shared/observables/turbolinksLoadedObservable"

loadedObservableEvent.subscribe(() =>
{
	// 2 hr units
	// var delayMs = 0;
	if(document.cookie.match("disp=triggered") === null) {
		window.setTimeout(function() {
			$("#test-it-all").modal({});

			var exp = new Date()
			exp.setHours(exp.getHours() + 2);
			document.cookie = "disp=triggered; Path=/; Expires=" + exp.toUTCString();
		}, 3500);
	}
});
